import axios from "axios";
import {authHeader} from "./auth-header";
import {REVIEW_API_URL} from "../containers/canopia/CanopiaUtils";

class ReviewService {

    loadAllJobs() {
        return axios.get(REVIEW_API_URL + "load-jobs", {headers: authHeader(), cache: 'no-store'});
    }
//     fetch(API_URL + "load-jobs", {headers: authHeader(), cache: 'no-store'})
// .then(response => {
//     let contentType = response.headers.get("content-type");
//     if (contentType && contentType.indexOf("application/json") !== -1) {
//         return response.json();
//     } else {
//         console.log("The content type is not JSON, found " + contentType);
//     }
// })
//     .then(json => json)
//     .catch(error => error)

    call(action, clientId, dateStr) {
        return axios.post(REVIEW_API_URL + action,
            {
                clientId,
                dateStr
            },
            {headers: authHeader(), cache: 'no-store'}); // set the auth header as the register process is not public on server side
    }

    async importReport(files, clientId, dateStr, action, ignoreDiff) {
        // Create an object of formData
        const formData = new FormData();

        // Update the formData object
        for (let i = 0; i < files.length; i++) {
            formData.append(
                `files`, files[i]
            );
        }
        formData.append(
            "clientId", clientId
        );
        formData.append(
            "dateStr", dateStr
        );
        // ESG checks only
        formData.append(
            "ignoreDiff", ignoreDiff
        );

        return axios.post(REVIEW_API_URL + action,
            formData,
            {headers: authHeader(), cache: 'no-store', encType: 'multipart/form-data'});
    }
}


const reviewService = new ReviewService();
export default reviewService;
